import { Component, DestroyRef, ViewChild, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { skip } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { NursingAuditService } from "src/app/services/nursing-audit.service";
import { Table } from "primeng/table";
import { UrcComponent } from "src/app/variance/urc/urc.component";
import { LocationAccessService } from 'src/app/services/location-access.service';
import { ThemeColorService } from 'src/app/services/theme-color.service';
import { ThemePreferenceService } from 'src/app/services/theme-preference.service';

@Component({
    selector: 'app-global-insights',
    templateUrl: './global-insights.component.html',
    styleUrls: ['./global-insights.component.scss'],
    standalone: false
})
export class GlobalInsightsComponent {
  authService = inject(AuthService);
  private auditService = inject(NursingAuditService);
  private locationAccessService = inject(LocationAccessService);
  private themeColorService = inject(ThemeColorService);
  private themePreferenceService = inject(ThemePreferenceService);
  private destroyRef = inject(DestroyRef);

  filter:any = {
    duration: 90, 
    ...this.locationAccessService.buildAuthorizedFilters(
      this.locationAccessService.buildInitialFilters(this.authService.user),
      this.authService.user
    ),
    adminId: [],
    serviceGroup: "All",
    resCode:"All"
  };
  selectedDays = 90;
  days: SelectItem[] = [
    { label: '90 Days', value: 90 },
    { label: '30 Days', value: 30 },
    { label: '7 Days', value: 7 }];
  overViews:any = {
    totalHighRisk: 0,
    totalInteraction:0,
    totalDiscrepincyRate:0,
  };
  adcEhrOverViews:any={
    adc:0,
    ehr:0,
    recordsMonitored: 0,
  }
  globalData:any = {
    resolutionCount:0,
    totalInteraction:0,
    totalDiscrepincyRate:0,
  };
  verifiedData: any ={
    verifiedCount: 0,
    verifiedRate:0,
  };
  UnaccountedData: any={
    unaccountedMed:0,
  }
  loading = true;
  overViewLoading = true
  adcLoading = true;
  verifiedLoading = true;
  medLoading = true;
  date: any = {}
  resolutionReport: any[] = [];
  resCount:any;
  @ViewChild("globalTT") globalTT!: Table;
  totalCount = 0;
  list:any;
  highRiskResolutionChartData:any={}
  discrepancyCharOptions: any = this.createDiscrepancyChartOptions();
  unaccountedMedTable!:boolean;
  verifiedTable!:boolean;
  @Input() deId=false;
  @ViewChild('varianceComponent') resolutionComp!: UrcComponent;
  iaFilter: any = {};
  infoPopUp = false;

  constructor() {
    this.themePreferenceService.preference$
      .pipe(skip(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.discrepancyCharOptions = this.createDiscrepancyChartOptions();
      });
  }

  private createDiscrepancyChartOptions(): any {
    const chartTextColor = this.themeColorService.resolve('--text-primary');
    const chartGridColor = this.themeColorService.resolve('--chart-grid-line');

    return {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: chartTextColor
          }
        },
        title: {
          display: true,
          text: 'Total Discrepancies',
          color: chartTextColor,
          size: 25,
          position: 'left'
        }
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: chartTextColor
          },
          grid: {
            color: chartGridColor
          }
        },
        y: {
          stacked: true,
          ticks: {
            color: chartTextColor
          },
          grid: {
            color: chartGridColor
          }
        }
      }
    };
  }

  isDeId(name: any){
    if(this.deId)
      return "xxxxxx xxxxxx"
    else
      return name
  }

  filterRecord(){
    const obj = {};
    (obj as any)["first"] = 0;
    this.refreshData();
  }

  refreshData(){
    this.loadOverViews();
    this.loadadcEhr();
    this.loadverifiedData();
    this.auditService.getGlobalData(this.filter).subscribe((res)=> {
      this.loadGlobalData(res); 
      this.loadResTable(res);  
      this.calldiscrepancyChart(res);
      this.resCount = (res as any)["resCount"];
      this.date = (res as any)['date'];
       this.date.startDate = new Date(this.gdfs(this.date.startDate)).setHours(0,0,0);
       this.date.endDate = new Date(this.date.endDate).setHours(23,59,59);
    })
  }

  loadOverViews(){
    this.auditService.getOverViews(this.filter).subscribe((res)=>{
      this.overViews = res
      this.overViewLoading = false
    })
   }

  loadGlobalData(res: any){
    this.globalData = res
    this.loading=false
  }
  loadadcEhr(){
    this.auditService.getadcEhrOverViews(this.filter).subscribe((res)=>{
      this.adcEhrOverViews = res
      this.adcLoading = false
    })
  }
  loadverifiedData(){
    this.auditService.getverifiedOverViews(this.filter).subscribe((res) => {
      if ((res as any)["verifiedProject"] != undefined && (res as any)["verifiedProject"].length > 0){
      this.verifiedData = (res as any)["verifiedProject"][0]
      this.verifiedLoading = false
      }
      else
      this.verifiedData['verified'] = 0
      this.verifiedLoading = false
    })
  }

  loadResTable(res: any){
    this.resolutionReport = res["resolutionTable"]
    this.UnaccountedData = res["medCount"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); //to format with commas
    this.medLoading = false;
  }

  getDiscrepincyRate(row: any){
    // this.resCount.forEach((count)=> {
    const totalCount = this.resCount[0]["resCount"]
    const calc = ((row["count"]/totalCount)*100)
    // let riskPercent = calc.toString()
    const result = calc.toFixed(2);
    // })
    // this.overViewLoading = false
    return result + '%'
  }

  getverifiedRate(){
    let rate = "";
    if(this.verifiedData.verified){
      rate = (this.verifiedData.verified/parseFloat(this.overViews.totalHighRisk.replace(",", '')) *100).toPrecision(2)
      this.verifiedLoading = false
    }
    else{
      rate = "0.00"
    }
    return rate
  }

  updateLookbackPeriod(event: any) {
    const lookbackPeriod = event["value"];
    this.filter.duration = lookbackPeriod;
    this.refreshData();
  }

  gdfs(s: string){
    const d = s.substring(0,10).split('-')
    return d[1] + '-' + d[2] + '-' + d[0]
  }

  calldiscrepancyChart(res: any){
    const labels = res['resList']
    let data = res['dataSets'].map((row: any) => {
      if(this.deId){
         row.label = "XXXXXX XXXXXX"
      }
       return(row)});
    // Add borderRadius, borderWidth, borderColor, and backgroundColor to each dataset for Chart.js
    if (Array.isArray((data))) {
      data = data.map(ds => ({
        ...ds,
        borderRadius: 10,
      }));
    }
    this.highRiskResolutionChartData = {
      labels: labels,
      datasets: data
    };
  }
  
  showUnaccountedMeds(){
    this.unaccountedMedTable = true;
  }

  openFilterModuleAfterMore(filterInputs: any){
    this.resolutionComp.openVarianceFilter(filterInputs);
}

  removeFilter(filter: any){
    filter.adminId = filter.employeeId      
    this.resolutionComp.removeVarianceFilters(filter, this.selectedDays);
  }


  updatedDate(filter: any){
    this.date.startDate = new Date(this.gdfs(filter.startDate)).setHours(0,0,0);
    this.date.endDate = new Date(this.gdfs(filter.endDate)).setHours(23,59,59);
  }

  sendData(){
    const filterData = {}
    for(const i in this.filter){
      (filterData as any)[i] = this.filter[i];
    };
    (filterData as any)['resolution'] = ['Unreconciled Dose: Single-User', 'Unreconciled Dose: Multi-User'];
    (filterData as any)['ia'] = true;
    (filterData as any)['initializing'] =true;
    this.iaFilter = filterData
    return filterData
  }

  showVerified(){
    this.verifiedTable = true;
  }

  showInfo(){
    this.infoPopUp = true;
  }
}
